import * as yup from 'yup';
// Inner error object
const errorObjectSchema = yup.object({
  code: yup.string().required(),
  message: yup.string().required(),
  internalMessage: yup.string().required(),
  stackTraceMessage: yup.string().nullable().default(null),
});

// Wrapper with 'error' property
export const apiErrorResponseSchema = yup.object({
  error: errorObjectSchema.required(),
});

export type ApiErrorObject = yup.InferType<typeof errorObjectSchema>;
export type ApiErrorResponse = yup.InferType<typeof apiErrorResponseSchema>;
